import { useMemo } from 'react';
import { isOwnedStation } from '../helpers';
import { useStations } from './useStations';
import { Station } from '@app/core/types/stations';

/**
 * Returns only stations owned by the authenticated client.
 * Optionally accepts an extra filter for specific screens.
 */
export function useOwnedStations(filter?: (station: Station) => boolean): readonly Station[] {
  const stations = useStations(isOwnedStation);

  return useMemo(() => (filter ? stations.filter(filter) : stations), [stations, filter]);
}
